document.addEventListener("DOMContentLoaded", function() {
    const videoOverlay = document.getElementById("videoOverlay");
    const showVideoButton = document.getElementById("showVideoButton");
    const closeVideoButton = document.getElementById("closeVideo");
    const videoContainer = document.querySelector(".video-container");
    const videoPlaceholder = document.getElementById("videoPlaceholder");
  
    if (showVideoButton) {
      showVideoButton.addEventListener("click", function(event) {
        event.preventDefault(); 
        
        
        videoPlaceholder.style.display = "none"; 
  
        const iframe = document.createElement("iframe");
        iframe.id = "iframe-container";
        iframe.src = "https://player.vimeo.com/video/1041644513?badge=0&autopause=0&player_id=0&app_id=58479";
        iframe.frameBorder = "0";
        iframe.allow = "autoplay; fullscreen; picture-in-picture; clipboard-write";
        iframe.title = "WP Collective homepage video 12-2024";
        iframe.style.display = "block"; 
  
        iframe.onload = function() {
          videoOverlay.style.display = "flex"; 
          closeVideoButton.style.display = "block";
        };
  
        videoContainer.appendChild(iframe);
      });
    }
  
    if (closeVideoButton) {
      closeVideoButton.addEventListener("click", function() {
        if (videoOverlay) {
          videoOverlay.style.display = "none";
          
          const iframe = document.getElementById("iframe-container");
          if (iframe) {
            iframe.remove();  
          }
        }
      });
    }
  });
  